import { Table } from '@mui/material';
import React from 'react';

import { SiteSchemaRow } from '../../molecules/SiteSchemaRow';

import { SiteSchemaTableProps } from '.';


export const SiteSchemaTable: React.FC<SiteSchemaTableProps> = ({
  hasEditPermissions,
  siteSchemaTableData,
  onEditClick
}) => {
  return (
    <Table size="small">
      {siteSchemaTableData.map((siteSchemaRowData, index) => 
        <SiteSchemaRow key={index} siteSchemaRowData={siteSchemaRowData} onEditClick={onEditClick} hasEditPermissions={hasEditPermissions}/>
      )}
    </Table>
  );
};